import React, { createContext, useReducer } from "react";
import { createMuiTheme } from "@material-ui/core";
import { THEME } from "./action-types";

const ThemeContext = createContext();

const darkTheme = createMuiTheme({
  palette: {
    primary: { main: "#349ce4" },
    secondary: { main: "#f4323f" },
    error: { main: "#f44336" },

    type: "dark",
    background: { paper: "#2a3640", default: "#fafafa" },
  },

  typography: {
    // fontFamily: ["Noto Sans", "Noto Sans Thai"].join(","),
    fontFamily: ["Kanit"].join(","),

    h5: {
      fontWeight: 300,
      fontSize: "1.4rem",
    },
    h6: {
      fontWeight: 300,
      fontSize: "1rem",
    },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500, fontSize: "0.85rem" },
    body2: { fontWeight: 400 },
  },
});

const lightTheme = createMuiTheme({
  palette: {
    primary: { main: "#e16733" },
    secondary: { main: "#c9c9c9" },
    error: { main: "#f44336" },
    type: "light",
    background: { paper: "#fff", default: "#fafafa" },
  },

  typography: {
    fontFamily: ["Kanit"].join(","),
    h5: {
      fontWeight: 200,
      fontSize: "1.4rem",
    },
    h6: {
      fontWeight: 200,
      fontSize: "1rem",
    },
    subtitle1: { fontWeight: 200 },
    subtitle2: { fontWeight: 200, fontSize: "0.85rem" },
    body2: { fontWeight: 200 },
    body1: { fontWeight: 400 },
  },
});

const reducer = (state, action) => {
  switch (action.type) {
    case THEME.toggleTheme:
      return action.mode === "light" ? lightTheme : darkTheme;
    default:
      return state;
  }
};

const checkTheme = (theme) => {
  if (theme === "light") {
    return lightTheme;
  } else {
    return lightTheme;
  }
};

const ThemeContextProvider = (props) => {
  let [theme, dispatchTheme] = useReducer(
    reducer,
    checkTheme(localStorage.getItem("theme"))
  );
  const value = { theme, dispatchTheme };
  return (
    <ThemeContext.Provider value={value}>
      {props.children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext, ThemeContextProvider };

export const toggleTheme = (mode) => ({
  type: THEME.toggleTheme,
  mode,
});
